module.exports = __webpack_public_path__ + "static/media/app-store-badge-ru.3498497d.svg";